var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col xl:flex-row gap-4" },
    [
      _c("PageHeadContainer", {
        class: _vm.getRoleAdmin ? `profileCard` : `managerProfileCard`,
        attrs: { title: _vm.managerName },
        scopedSlots: _vm._u(
          [
            _vm.isUserDisabled
              ? {
                  key: "status",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-wrap h-5 -ml-1 space-y-1 sm:self-center sm:space-y-0",
                        },
                        [
                          _vm.isManagerSuspended && !_vm.isEmailUnconfirmed
                            ? _c("Badge", {
                                staticClass: "mr-2",
                                attrs: {
                                  styleClasses: "py-0.5 px-2",
                                  color: _vm.BadgeColor.DANGER,
                                  value: _vm.managerSuspendedText,
                                },
                              })
                            : _vm._e(),
                          !_vm.isManagerSuspended && _vm.isEmailUnconfirmed
                            ? _c("Badge", {
                                attrs: {
                                  styleClasses: "py-0.5 px-2",
                                  color: _vm.BadgeColor.WARNING,
                                  value: _vm.emailStatusText,
                                },
                              })
                            : _vm._e(),
                          _vm.isManagerSuspended && _vm.isEmailUnconfirmed
                            ? _c("Badge", {
                                staticClass: "mr-2",
                                attrs: {
                                  styleClasses: "py-0.5 px-2",
                                  color: _vm.BadgeColor.DANGER,
                                  value: _vm.managerSuspendedText,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "avatar",
              fn: function () {
                return [
                  _c("PageHeadAvatar", {
                    attrs: {
                      avatar: _vm.manager.user.avatar,
                      user: _vm.manager.user,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "role",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "mb-8 flex flex-row flex-wrap items-center",
                    },
                    [
                      _vm.jobTitle &&
                      _vm.jobTitle !== "." &&
                      _vm.jobTitle.length > 0
                        ? _c("div", {}, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-lg leading-normal text-primary-black pr-1",
                              },
                              [_vm._v(" " + _vm._s(_vm.jobTitle) + " ")]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [
                  !_vm.getRoleAdmin
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row gap-5 items-center managerButton",
                        },
                        [
                          _c("custom-switch", {
                            attrs: {
                              value: _vm.isManagerSuspended,
                              disabled: _vm.showActivateTooltip,
                              deActiveText: "Deactivate",
                              activeText: "Activate",
                            },
                            on: { input: _vm.handleSwitchChange },
                          }),
                          _vm.showActivateTooltip
                            ? _c("Tooltip", {
                                staticClass: "h-12",
                                attrs: {
                                  disabled: _vm.ableToActivate,
                                  title:
                                    "To activate this manager you need to upgrade your subscription",
                                  tooltipClasses: "w-56",
                                },
                              })
                            : _vm._e(),
                          _vm.isEmailUnconfirmed
                            ? _c(
                                "Tooltip",
                                {
                                  staticClass: "h-12",
                                  attrs: {
                                    disabled:
                                      _vm.isResendInvitationTooltipDisabled,
                                    title: _vm.resendInvitationTooltipText,
                                    tooltipClasses: "w-auto",
                                  },
                                },
                                [
                                  _c("ManagerResendInvitation", {
                                    attrs: {
                                      disabled: _vm.isResendInvitationDisabled,
                                      adminUserId: _vm.currentUserId,
                                      managerId: _vm.manager.id,
                                      givenName: _vm.manager.user.given_name,
                                      familyName: _vm.manager.user.family_name,
                                    },
                                    on: {
                                      invitationResent: function ($event) {
                                        _vm.invitationResent = true
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({
                                            resendInvitation,
                                            processing,
                                            invitationResent,
                                          }) {
                                            return [
                                              _c("UiButton", {
                                                attrs: {
                                                  variant: "gray",
                                                  size: "lg",
                                                  buttonClasses: "customResend",
                                                  buttonText:
                                                    "Resend invitation",
                                                  processing: processing,
                                                  disabled:
                                                    _vm.isResendInvitationDisabled,
                                                },
                                                on: { click: resendInvitation },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "icon",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "ViewIconBlack",
                                                            {}
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                    {
                                                      key: "hover-icon",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "ViewIconBlack",
                                                            {}
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                    {
                                                      key: "disabled",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "ViewIconBlack",
                                                            {}
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1124031324
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "customMessage",
                      attrs: { disabled: _vm.isEmailUnconfirmed },
                      on: {
                        click: _vm.message,
                        mouseover: function ($event) {
                          _vm.isHoveredChat = true
                        },
                        mouseout: function ($event) {
                          _vm.isHoveredChat = false
                        },
                      },
                    },
                    [
                      !_vm.isHoveredChat
                        ? _c("MessageIcon", { staticClass: "w-4 h-4" })
                        : _vm._e(),
                      _vm.isHoveredChat
                        ? _c("MessageIconHover", { staticClass: "w-4 h-4" })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.isEmailUnconfirmed
                    ? _c("Tooltip", {
                        staticClass: "h-12",
                        attrs: {
                          disabled: _vm.isResendInvitationTooltipDisabled,
                          title: _vm.resendInvitationTooltipText,
                          tooltipClasses: "w-auto",
                        },
                      })
                    : _vm._e(),
                  _vm.isManagerSuspended
                    ? _c("Tooltip", {
                        staticClass: "h-12",
                        attrs: {
                          disabled: _vm.ableToActivate,
                          title:
                            "To activate this manager you need to upgrade your subscription",
                          tooltipClasses: "w-56",
                        },
                      })
                    : _vm._e(),
                  _vm.ableToActivate
                    ? _c(
                        "button",
                        {
                          staticClass: "customDelete",
                          on: {
                            click: function ($event) {
                              return _vm.onDeleteManager()
                            },
                            mouseover: function ($event) {
                              _vm.isHoveredDelete = true
                            },
                            mouseout: function ($event) {
                              _vm.isHoveredDelete = false
                            },
                          },
                        },
                        [
                          !_vm.isHoveredDelete
                            ? _c("DeleteIcon", { staticClass: "w-4 h-4" })
                            : _vm._e(),
                          _vm.isHoveredDelete
                            ? _c("DeleteIconHover", { staticClass: "w-4 h-4" })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "icons",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex flex-col lg:flex-row gap-8" },
                    [
                      _c(
                        "div",
                        [
                          _c("PageHeadIcon", {
                            attrs: {
                              content: _vm.location,
                              title: "Location:",
                            },
                          }),
                          _c("PageHeadIcon", {
                            attrs: { content: _vm.email, title: "Email:" },
                          }),
                          _c("PageHeadIcon", {
                            attrs: { content: _vm.phone, title: "Work Phone:" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("PageHeadIcon", {
                            attrs: {
                              content: _vm.createdDate,
                              title: "Joined:",
                            },
                          }),
                          _c("PageHeadIcon", {
                            attrs: {
                              content: _vm.fullName,
                              title: "Added By:",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "annotation",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "p-2 bg-snow-white flex flex-col md:flex-row items-center justify-center w-auto border-transparent rounded-lg",
                    },
                    [
                      _c("PageInfo", {
                        attrs: {
                          extend: true,
                          noContent: "0",
                          title: "Completed Clients",
                          content: _vm.completedProjects,
                        },
                      }),
                      _c("PageInfo", {
                        attrs: {
                          noContent: "0",
                          title: "Active Clients",
                          content: _vm.activeProjects,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm.getRoleAdmin
        ? _c("div", { staticClass: "document-section mr-4" }, [
            _c(
              "div",
              { staticClass: "flex flex-row gap-5 items-center" },
              [
                _vm.showActivateTooltip
                  ? _c("Tooltip", {
                      staticClass: "h-12",
                      attrs: {
                        disabled: _vm.ableToActivate,
                        title:
                          "To activate this manager you need to upgrade your subscription",
                        tooltipClasses: "w-56",
                      },
                    })
                  : _vm._e(),
                _vm.isEmailUnconfirmed
                  ? _c(
                      "Tooltip",
                      {
                        staticClass: "h-12",
                        attrs: {
                          disabled: _vm.isResendInvitationTooltipDisabled,
                          title: _vm.resendInvitationTooltipText,
                          tooltipClasses: "w-auto",
                        },
                      },
                      [
                        _c("ManagerResendInvitation", {
                          attrs: {
                            disabled: _vm.isResendInvitationDisabled,
                            adminUserId: _vm.currentUserId,
                            managerId: _vm.manager.id,
                            givenName: _vm.manager.user.given_name,
                            familyName: _vm.manager.user.family_name,
                          },
                          on: {
                            invitationResent: function ($event) {
                              _vm.invitationResent = true
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({
                                  resendInvitation,
                                  processing,
                                  invitationResent,
                                }) {
                                  return [
                                    _c("UiButton", {
                                      attrs: {
                                        variant: "gray",
                                        size: "lg",
                                        buttonClasses: "customResend",
                                        buttonText: "Resend invitation",
                                        processing: processing,
                                        disabled:
                                          _vm.isResendInvitationDisabled,
                                      },
                                      on: { click: resendInvitation },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [_c("ViewIconBlack", {})]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "hover-icon",
                                            fn: function () {
                                              return [_c("ViewIconBlack", {})]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "disabled",
                                            fn: function () {
                                              return [_c("ViewIcon", {})]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2393278747
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.getRoleAdmin
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bg-white rounded-lg shadow-md xl:h-64 documentSection",
                  },
                  [
                    _vm._m(0),
                    _c("DocumentsSidebar", {
                      attrs: {
                        managerUserId: _vm.managerUserId,
                        managerFullName: _vm.managerFullName,
                        companyId: _vm.companyId,
                        isCustomHeight: true,
                        getBottom: "bottom-1.5",
                        managerId: _vm.managerId,
                        currentUser: _vm.currentUser,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "border-b border-gray-200 px-3 pt-4 pb-1" },
      [
        _c("nav", { staticClass: "-mb-px flex" }, [
          _c(
            "a",
            {
              staticClass:
                "whitespace-no-wrap pb-1 border-b-2 border-transparent font-normal text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-secondary-black hover:text-gray-700 hover:border-secondary-black",
              attrs: { href: "#" },
            },
            [_vm._v(" All documents ")]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }